<h5 mat-dialog-title>{{ 'SelectAGoalPlan' | translate: {Default: "Select A Goal Plan"} }}</h5>

<mat-dialog-content>
    <div *ngIf="selectedGoal" class="selected-goal page-description-section">
        <h6>{{ 'SelectedGoalPlan' | translate: {Default: "Selected Goal Plan"} }}: {{selectedGoal.name}}</h6>

        <app-bootstrap-alert 
            *ngIf="selectedGoal?.status?.id === 'Archived'"
            localizationCode="InactiveGoalPlanSelectedWarning" 
            type="danger">
        </app-bootstrap-alert>
    </div>

    <app-data-grid-comp
        [tableId]="db_tables.GoalPlans"
        [columns]="columns"
        [filterCategories]="filterCategories"
        [view]="view"
        [gridDataResult]="gridDataResult"
        [isLoading]="isLoading"
        [pageSize]="pageSize"
        [skip]="skip"
        [rowSelectionSettings]="{
            canSelectRows: true,
            selectRowBy: 'id',
            showDeleteAllButton: false,
            selectableMode: 'single'
        }"
        searchable="true"
        hideActionButtons="true"
        [sortable]="{
            mode: 'multiple'
        }"
        [sortableColumns]="sortableColumns"
        (emitSortEvent)="sortChange($event)"
        [isLoading]="isLoading"
        [clearSelectedItems]="clearSelectedItems"
        (emitPageChangeEvent)="pageChange($event)"
        (emitSearchEvent)="search($event)"
        (emitFilterEvent)="filterCallback($event)"
        (emitSortEvent)="sortChange($event)"
        (emitSelectedRows)="selectedRowsChanged($event)"
    ></app-data-grid-comp>
    
</mat-dialog-content>

<mat-dialog-actions>
    <button class="mat-raised-button" appPreventDoubleClick (throttledClick)="close()">{{ 'Close' | translate: {Default: "Close"} }}</button>
    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="save()" [disabled]="!selectedGoal">{{ 'Save' | translate: {Default: "Save"} }}</button>
</mat-dialog-actions>